export default {
  adminFeesResults(currentState, value) {
    const state = currentState;
    state.adminFeesResults = Object.assign([], value);
  },
};
